import {Component, OnInit} from '@angular/core';
import {ITableColumn} from 'app/main/shared/shared/table/table-column';
import {ITableDataItem} from 'app/main/shared/shared/table/table-data-item';
import {ITableCellItem} from '../../../../../shared/shared/table/table-cell';
import {IDocumentDto} from '../../../dto/document-listing.dto';
import { Field } from 'app/interfaces/fields';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-metadata-field-column',
    templateUrl: './metadata-field-column.component.html',
    styleUrl: './metadata-field-column.component.scss',
})
export class MetadataFieldColumnComponent implements  ITableCellItem, OnInit {
    value: string ='';

    constructor(private _translocoService: TranslocoService) {}

    ngOnInit(): void {
        this.value = this.extractValue();
    }

    dataItem: ITableDataItem;
    columnOptions: ITableColumn<{details:{ id: number}}>;

    private extractValue():string{
        const fieldTypeId = this.columnOptions?.details?.details?.id;
        const metadataItemsList = (<IDocumentDto>this.dataItem)?.fields_datas?.data;
        if(fieldTypeId && metadataItemsList){
            const metadataItems = Object.values(metadataItemsList).find(x=>x.selected_field_type_id == fieldTypeId) as Field;
            if(metadataItems){
                if(metadataItems.type === 'checkbox') {
                    return metadataItems.value ? this._translocoService.translate('General text (general) - Yes') : this._translocoService.translate('General text (general) - No');
                }
                return (metadataItems?.value as string) || (metadataItems?.alt_value as string) || '';
            }
        }

        return '';
    }
}
